// The session's CSRF token (ADR-032 double submit). It comes from the shell's `me` document
// (`GET /v1/me` in the AllCode admin, `/api/me` on the proxy) and lives only in this module's memory: never in localStorage, sessionStorage or a script-readable cookie, so a
// reload simply fetches it again with the session.

const UNSAFE_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);

export const CSRF_HEADER = "X-Nexus-CSRF";

/** Whether a request with this method must carry the CSRF header. */
export function isUnsafeMethod(method: string): boolean {
  return UNSAFE_METHODS.has(method.toUpperCase());
}

export interface CsrfToken {
  current(): string | null;
  set(token: string): void;
  clear(): void;
}

export function createCsrfToken(): CsrfToken {
  let token: string | null = null;
  return {
    current: () => token,
    set: (next) => {
      token = next;
    },
    clear: () => {
      token = null;
    },
  };
}
